<template>
  <div class="brand">
    <el-row v-if="task" type="flex" class="row-bg" align="middle">
      <img :src="qrcode" class="qrcode" v-if="qrcode"></img>
      <div style="margin-left: 20px;">
        <div class="brand-info">
          <div>长按或扫码接受邀请！</div>
          <div style="font-size: 12px;">评选内容由组织者分配</div>
        </div>
      </div>
    </el-row>
    <div v-else-if="baseuser" class="row-bg" align="middle">
      <img :src="qrcode" class="qrcode" v-if="qrcode"></img>
      <div style="margin-top: 20px;">
        <div class="brand-info">
          <div style="font-size: 12px;text-align: center">微信扫一扫或点击查看详情按钮访问主页</div>
        </div>
      </div>
    </div>
    <el-row v-else="" type="flex" class="row-bg" justify="space-between" align="middle">
      <div>
        <div class="brand-name">Fotoo 征集一下</div>
        <div class="brand-info">
          <div>照片/视频征集、投稿小程序</div>
          <div>微信扫一扫，查看详情</div>
        </div>
      </div>
      <img :src="qrcode" class="qrcode" v-if="qrcode"></img>
    </el-row>
  </div>
</template>

<script>
  import App from '../util/comfun'
  export default {
    name: 'brand',
    props:{
      activity:{
        type:Object,
        value:null
      },
      submission:{
        type:Object,
        value:null
      },
      task:{
        type:Object,
        value:null
      },
      baseuser:{
        type:Object,
        value:null
      },
    },
    data () {
      return {
        qrcode:'',
      }
    },
    components:{
    },
    methods:{
      async getQrcode(){
        //'http://129.204.34.202:8081/fotoo/wechatapplet/getActivityQrcode?autoColor=false&inHyaline=true&lineColor=0,0,0&page=pages/draftworks/work&scene=id%3D8397&width=430'
        let hash=location.hash
        if(hash.indexOf('#/submission')===0){
          this.qrcode=await App.System.Qrcode({
            autoColor:false,
            inHyaline:false,
            lineColor:'0,0,0',
            page:'pages/enter/enter',
            scene:encodeURIComponent('id='+this.submission.id
              +'&cid='+this.submission.activityId
              +'&imgid=1',
            ),
            width:430,
            appId:this.activity.vipType>20?'wxb85ef06b22c33674':'wx397090124c858e7c',
          },'URL')
        }else if(hash.indexOf('#/home')===0){
          let param={
            gotopath: '/person/pages/index',
            userId: this.baseuser.id,
          }
          let res = await App.demand('fotoo/wechatapplet/saveParam', 'GET', {
            param: JSON.stringify(param)
          });
          this.qrcode = await App.System.Qrcode({
            autoColor:false,
            inHyaline:false,
            lineColor:'0,0,0',
            page:'pages/enter/enter',
            scene:res.data,
            width:430,
            appId:this.baseuser.vipType>20?'wxb85ef06b22c33674':'wx397090124c858e7c',
          },'URL');
        }else if(this.activity){
          if(this.task){
            //gotopath=/judge/pages/index&activityId=16443&taskId=
            let param={
              gotopath: '/judge/pages/index',
              activityId: this.activity.activityId,
              taskId:this.task.id,
            }
            let res = await App.demand('fotoo/wechatapplet/saveParam', 'GET', {
              param: JSON.stringify(param)
            });
            this.qrcode = await App.System.Qrcode({
              autoColor:false,
              inHyaline:false,
              lineColor:'0,0,0',
              page:'pages/enter/enter',
              scene:res.data,
              width:430,
              appId:this.activity.vipType>20?'wxb85ef06b22c33674':'wx397090124c858e7c',
            },'URL');
          }else{
            this.qrcode=await App.System.Qrcode({
              autoColor:false,
              inHyaline:false,
              lineColor:'0,0,0',
              page:'pages/draftworks/work',
              scene:encodeURIComponent('id='+this.activity.activityId),
              width:430,
              appId:this.activity.vipType>20?'wxb85ef06b22c33674':'wx397090124c858e7c',
            },'URL')
          }
        }
      },
    },
    created(){
      console.log('brand',this.activity,this.submission)
      this.getQrcode()

    },

  }
</script>

<style scoped>
  .brand{
    width: 335px;
    height: 120px;
    opacity: 1;
    box-sizing: border-box;
    padding: 8px 5px;
  }
  .qrcode{
    width: 100px;
    height: 100px;
    opacity: 1;
    background-size: 100% 100%;
  }
  .brand-name{
    height: 22px;
    opacity: 1;
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #3dc4a7;
    line-height: 22px;
    margin-bottom: 3px;
  }
  .brand-info{
    opacity: 1;
    font-size: 14px;
    font-family: PingFangSC, PingFangSC-Light;
    font-weight: 300;
    text-align: left;
    color: #666666;
    line-height: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/brand.vue